import BaseExtension from './base';

import { createElement, removeClass } from '../utils';
import createSvg, { ERROR } from '../svgs';

const CN = 'rmp-ext-error';
const HIDDEN_CN = `${CN}--hidden`;
const ERROR_CONTENT = `${CN}__content`;

export default class ErrorExtension extends BaseExtension {
   constructor(player, state, options) {
      super(player, state, options, ['error']);
      this.logger.debug('error:extension:creating');

      this.onError = this.onError.bind(this);

      this.render();

      this.logger.debug('error:extension:created');
   }

   render() {
      this.$outer = createElement('div', { class: `${CN} ${HIDDEN_CN}`, tabindex: -1 });
      createSvg(this.$outer, ERROR, { class: 'error', width: 800, height: 800, viewBox: '0 0 16 16' });
      const error = createElement('div', { class: ERROR_CONTENT }, this.$outer);
      error.textContent = this.$t('error');
      this.logger.debug('error:extension:rendered');
   }

   onError() {
      this.logger.debug('error:extension:onError');
      removeClass(this.$outer, HIDDEN_CN);
   }

   getOuter() {
      return this.$outer;
   }

   destroy() {
      super.destroy();
      if (this.$outer) {
         const parent = this.$outer.parentNode;
         parent.removeChild(this.$outer);
         this.$outer = null;
      }
   }
}
